// Public client REST helpers.

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== 'undefined' && window.__REMOTEEYES_API__) ||
  '';

async function request(endpoint, options = {}) {
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = new Error(data.error || `HTTP ${response.status}`);
    err.data = data;
    throw err;
  }
  return response.json();
}

export const api = {
  resolveCode: (code) =>
    request('/api/sessions/resolve-code', {
      method: 'POST',
      body: JSON.stringify({ code }),
    }),

  getSessionPublic: (sessionId, token) =>
    request(`/api/sessions/${sessionId}/public?t=${encodeURIComponent(token || '')}`),

  uploadCapture: (sessionId, token, blob, kind, filename) => {
    const form = new FormData();
    form.append('file', blob, filename);
    form.append('kind', kind);
    form.append('token', token);
    return fetch(`${API_BASE}/api/sessions/${sessionId}/capture`, {
      method: 'POST',
      body: form,
    }).then((r) => {
      if (!r.ok) throw new Error('Upload failed');
      return r.json();
    });
  },
};

export { API_BASE };
